import axios from '@/axios/axios'
import qs from "qs";

export default {
  namespaced: true, 
  actions:{
    requestPlaceList(){
      return axios
      .get('/api/category/placeList')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    requestTargetList(){
      return axios
      .get('/api/category/targetList')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    requestLifeList(){
      return axios
      .get('/api/category/lifeList')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    requestIndustryList(context, type){
      return axios
      .get('/api/category/industryList', {
        params: {
          type: type
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    requestCategoryList(context, payload){
      return axios
      .get('/api/category/list', {
        params: {
          currentPage: payload.currentPage,
          perPage: payload.perPage,
          sortBy: payload.sortBy,
          sortDesc: payload.sortDesc,
          searchText : payload.searchText,
          type : payload.type
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    requestCategory(context, idx){
      return axios
      .get('/api/category/' + idx)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    requestCategoryByNameAndIndustryIdxList(context, payload){
      return axios
      .post('/api/category/byNameAndIndustryIdxList', {
        type: payload.type,
        nameList: payload.nameList,
        industryIdxList: payload.industryIdxList
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    requestCategoryNameByIndustryIdxList(context, industryIdxList){
      return axios
      .get('/api/category/name/byIndustryIdxList', {
        params:{
          industryIdxList: industryIdxList
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" })
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    saveProductCategory(context, payload){
      return axios
      .post('/api/admin/category/product/save', null, {
        params:{
          isModify: payload.isModify,
          idx: payload.idx,
          name: payload.name,
          industryIdx: payload.industryIdx,
          placeIdx: payload.placeIdx
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    saveServiceCategory(context, payload){
      return axios
      .post('/api/admin/category/service/save', null, {
        params:{
          isModify: payload.isModify,
          idx: payload.idx,
          name: payload.name,
          industryIdx: payload.industryIdx,
          targetIdx: payload.targetIdx,
          lifeIdx: payload.lifeIdx
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    deleteCategory(context, categoryIdxList){
      return axios
      .delete('/api/admin/category/remove', {
        params:{
          categoryIdxList: categoryIdxList
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" })
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    requestCorpCategoryGroupByIndustryIdxList(context, payload){
      return axios
      .get('/api/corp/category/getCategoryGroupByIndustryIdxList', {
        params:{
          industryIdxList: payload.industryIdxList,
          type: payload.type
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" })
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    requestCategoryGroupByIndustryIdxList(context, payload){
      return axios
      .get('/api/category/getCategoryGroupByIndustryIdxList', {
        params:{
          industryIdxList: payload.industryIdxList,
          type: payload.type
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" })
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    deleteService(context, idxList){
      return axios
      .get('/api/corp/service/delete', {
        params:{
          idxList: idxList
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" })
        }
      })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.log(error)
        return Promise.reject(error)
      })
    },
    requestGetPlaceListByInOut(context, inOut){
        return axios
        .get('/api/category/getPlaceListByInOut', {
            params:{
              inOut: inOut
            }
        })
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            console.log(error)
            return Promise.reject(error)
        })
    },
    requestGetInOutDetailList(){
        return axios
        .get('/api/category/getInOutDetailList', {
            params:{
            }
        })
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            console.log(error)
            return Promise.reject(error)
        })
    },
    requestGetLifeListByTargetIdx(context, targetIdx){
        return axios
        .get('/api/category/getLifeListBytargetIdx', {
            params:{
                targetIdx: targetIdx
            }
        })
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            console.log(error)
            return Promise.reject(error)
        })
    },
  }
}